import { createTheme } from '@mui/material';

import defaultMuiThemeOptions from '../defaultMuiThemeOptions';
import { AppTheme, PaletteOptions, Theme } from '../types/AppTheme';

const palette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#92140c',
    contrastText: '#fff',
  },
  secondary: {
    main: '#92140c',
    contrastText: '#fff',
  },
  background: {
    default: '#1e1e24',
    paper: '#fff',
  },
  text: {
    primary: '#fff',
  },
  error: {
    main: '#e85050',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f67044',
    contrastText: '#ffffff',
  },
  success: {
    main: '#72d59c',
    contrastText: '#ffffff',
  },
  custom: {
    background: {
      contrastText: '#ffffff',
      dark: '#001f3e',
    },
    upgradeBlock: {
      background: '#00000040',
      contrastText: '#fff',
      arrow: '#00000066',
    },
    lightGray: '#eeeeee',
    gray: '#4D4F53',
    secondaryAccent: {
      altContrastText: '#ee4035',
      main: '#ffffff33',
      contrastText: '#fff',
    },
    input: {
      background: '#eeeeee',
      color: '#000',
    },
  },
};

const theme: AppTheme = {
  name: 'Raisin Black',
  theme: createTheme({
    ...defaultMuiThemeOptions,
    palette,
  }) as Theme,
};

export default theme;
